import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const lines = ['A defined assessment sequence.', 'A structured complication classification.', 'A practical way to organize unresolved clinical questions.', 'A corrective planning worksheet.', 'And a complete professional documentation record.'];
export function FinalCTA() {
  return <section className="w-full bg-navy-900 px-5 py-16 text-white md:px-8 md:py-24" data-id="element-153" data-mp="m4f1uabi2bzz">
      <div className="mx-auto max-w-3xl text-center" data-id="element-154" data-mp="h5vi8gkdpcas">
        <p className="font-serif text-lg font-bold text-gold-300" data-id="element-155" data-mp="h5c6xip8hm5q">
          Every veneer complication case deserves an organized assessment.
        </p>
        <h2 className="mt-3 font-serif text-[2rem] font-extrabold leading-tight sm:text-5xl" data-id="element-156" data-mp="qvx0grq1w0hs">
          Stop rebuilding your documentation workflow from scratch.
        </h2>
        <p className="mt-6 text-lg leading-relaxed text-navy-100" data-id="element-157" data-mp="14t3iul6v3x6h">
          When a veneer complication appears, you shouldn’t have to invent a new documentation process
          every time. You can start with a consistent framework.
        </p>
        <ul className="mx-auto mt-8 max-w-xl space-y-3 text-left" data-id="element-158" data-mp="2h4ss4ns5g3wy">
          {lines.map(l => <li key={l} className="flex gap-3 text-lg" data-id="element-159" data-mp="2m1swmu9coyly">
              <CheckCircle2Icon className="mt-0.5 h-6 w-6 shrink-0 text-gold-400" aria-hidden="true" data-id="element-160" data-mp="2r1xfus1n87fv" />
              {l}
            </li>)}
        </ul>
        <div className="mt-10 rounded-3xl bg-navy-800 p-6 ring-1 ring-gold-500/40 sm:p-8" data-id="element-161" data-mp="2v2zgndb7krjy">
          <p className="font-serif text-xl font-bold leading-snug sm:text-2xl" data-id="element-162" data-mp="301aq3mxld01n">
            Five decision stages. Six practical clinical volumes. Five complementary tools.{' '}
            <span className="text-gold-400" data-id="element-163" data-mp="39somhlu8xjqk">One complete veneer complication planning system.</span>
          </p>
          <p className="mt-5 text-5xl font-extrabold" data-id="element-164" data-mp="3est45f6w4kid">
            $27 <span className="text-lg font-semibold text-navy-100" data-id="element-165" data-mp="3istu9x3cqk59">USD — One-Time Payment</span>
          </p>
          <div className="mt-6 flex justify-center" data-id="element-166" data-mp="1jntrdtdl5xxt">
            <CTAButton size="xl" label="Yes! Organize My Next Veneer Complication Case" data-id="element-167" data-mp="1jolai4pzy377" />
          </div>
          <p className="mt-5 text-sm text-navy-100" data-id="element-168" data-mp="1en5q8evn80pv">
            ✓ Immediate Digital Access · ✓ 6 Practical Volumes + 5 Bonuses · ✓ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}